import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {TermsAndConditionsComponent} from './terms-and-conditions.component';
import {OuterPagesGuardService} from '../../../guards/outer-pages-guard.service';
import {AuthGuardService} from "../../../guards/auth-guard.service";

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.termsAndConditionsPublic.pageInRouting,
    data: {data: PAGES_AND_PATHS.termsAndConditions},
    component: TermsAndConditionsComponent,
    canActivate: [OuterPagesGuardService],
    loadChildren: () => import('./terms-and-conditions.module').then(m => m.TermsAndConditionsModule)
  },
  {
    path: PAGES_AND_PATHS.termsAndConditions.pageInRouting,
    data: {data: PAGES_AND_PATHS.termsAndConditions},
    component: TermsAndConditionsComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./terms-and-conditions.module').then(m => m.TermsAndConditionsModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TermsAndConditionsRoutingModule { }
